import React, { useState, useEffect } from 'react';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import { useParams } from 'react-router-dom';
import { getApi } from '../../api/endpoints';
import DetailsComponent from '../../components/DetailsComponent';
import Distributor from '../../models/Distributor';
import TabsComponent from '../../components/TabsComponent';
import RfidsListing from '../rfidstab/Listing.js';
import ChargingStationsListing from '../../pages/charging_stations/Listing';
import OperatorsListing from '../../pages/operator/Listing';
import BatteriesListing from '../../pages/batteries/Listing';
import PartnerAssetBillsListing from '../../pages/partner_asset_bills/Listing';
import UserDocuments from '../document/Listing.js';
import SettingsTab from './SettingsTab.js';
import { toast } from 'react-toastify';

const Show = () => {
  const [distributorDetails, setDistributorDetails] = useState(new Distributor().toStateJson());
  const [hasAssetEarnings, setHasAssetEarnings] = useState(false);
  const [fetchApi] = getApi('distributorDetails');
  const [tabs, setTabs] = useState([]);
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  useEffect(() => {
    const defaultTabs = [
      {
        event: 'operators',
        heading: 'Operators List',
        component: <><OperatorsListing /></>,
        ui_action: 'view_operators_tab_list'
      },
      {
        event: 'batteries',
        heading: 'Batteries',
        component: <BatteriesListing defaultParams={{ owner_id: params.id, filters: { owner_type: ["User"] } }} />,
        ui_action: 'view_batteries_tab_list'
      },
      {
        event: 'charging_stations',
        heading: 'Charging Stations',
        component: <ChargingStationsListing />,
        ui_action: 'view_charging_stations_tab_list'
      },
      {
        event: 'rfid_cards',
        heading: 'Voltup ID Cards',
        component: <RfidsListing defaultParams={{ filters: { owner_type: "User" }, owner_id: params.id }} />,
        ui_action: 'view_rfids_tab_list'
      },
      {
        event: 'user_documents',
        heading: 'User Documents',
        component: <UserDocuments />,
        ui_action: 'view_user_documents'
      },
      {
        event: 'settings',
        heading: 'Settings',
        component: <SettingsTab distributorDetails={distributorDetails} getRecord={getRecord} />,
        ui_action: 'view_user_settings_tab'
      }
    ];

    if (hasAssetEarnings) {
       defaultTabs.push({
        event: 'partner_asset_bills',
        heading: 'Partner Asset Bills',
        component: <PartnerAssetBillsListing />,
        ui_action: 'view_partner_asset_bills_tab_list'
      });
    }

    setTabs(defaultTabs);
  }, [distributorDetails]);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setHasAssetEarnings(response.data.charging_partner['has_asset_earnings?']);
      setDistributorDetails((new Distributor(response.data.charging_partner)).toStateJson());
    } catch (error) {
      toast.error(error.data.message || "Error occured while fetching details");
    }
  };

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.DistributorDetailsPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Distributors", url: '/distributors' }, { label: "Details" }]}
      className={'distributors-details-config-page'}
    >
      <PageContentWrapper contentHeading={"Distributor Details"}>
        <DetailsComponent data={distributorDetails} />
        <TabsComponent defaultActiveEvent={'operators'} data={tabs} />
      </PageContentWrapper>
    </Page>
  );
};

export default Show;
